/**
 * İzin Hesaplama Engine — 2026
 * 4857 sayılı İş Kanunu Madde 53
 */

export const YILI = 2026;

// ============================================================================
// İZİN SÜRELERİ (İş Kanunu 4857 Madde 53)
// ============================================================================

export interface IzinDilimi {
  minYil: number;
  maxYil: number;
  gun: number;
  aciklama: string;
}

export const IZIN_DILIMLERI: IzinDilimi[] = [
  {
    minYil: 1,
    maxYil: 5,
    gun: 14,
    aciklama: "1–5 yıl arası çalışma süresi",
  },
  {
    minYil: 5,
    maxYil: 15,
    gun: 20,
    aciklama: "5–15 yıl arası çalışma süresi",
  },
  {
    minYil: 15,
    maxYil: Infinity,
    gun: 26,
    aciklama: "15 yıl ve üzeri çalışma süresi",
  },
];

// Özel yaş grupları (İş Kanunu 53/3)
export const OZEL_YAS_MINIMUM_IZIN = 20;

// ============================================================================
// TİPLER
// ============================================================================

export interface IzinSonuc {
  kidemYili: number;
  kidemAyi: number;
  kidemGunu: number;
  toplamGun: number;
  izinGunu: number;
  izinDilimi: string;
  ozelYasUygulandiMi: boolean;
  ozelYasIzinGunu: number;
  izinHakkiVar: boolean;
  hataMesaji: string | null;
}

// ============================================================================
// HESAPLAMA
// ============================================================================

export function hesaplaIzin(params: {
  iseBaslamaTarihi: string;
  hesapTarihi?: string;
  calIsanYasi?: number;
}): IzinSonuc {
  const { iseBaslamaTarihi, hesapTarihi, calIsanYasi } = params;

  const baslangic = new Date(iseBaslamaTarihi);
  const bitis = hesapTarihi ? new Date(hesapTarihi) : new Date();

  const diffMs = bitis.getTime() - baslangic.getTime();
  const toplamGun = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (toplamGun < 0) {
    return {
      kidemYili: 0,
      kidemAyi: 0,
      kidemGunu: 0,
      toplamGun: 0,
      izinGunu: 0,
      izinDilimi: "",
      ozelYasUygulandiMi: false,
      ozelYasIzinGunu: 0,
      izinHakkiVar: false,
      hataMesaji: "İşe başlama tarihi bugünden sonra olamaz.",
    };
  }

  // Kıdem hesaplama
  const yilFark = bitis.getFullYear() - baslangic.getFullYear();
  const ayFark = bitis.getMonth() - baslangic.getMonth();
  const gunFark = bitis.getDate() - baslangic.getDate();

  let kidemYili = yilFark;
  let kidemAyi = ayFark;
  let kidemGunu = gunFark;

  if (kidemGunu < 0) {
    kidemAyi--;
    const oncekiAy = new Date(bitis.getFullYear(), bitis.getMonth(), 0);
    kidemGunu += oncekiAy.getDate();
  }
  if (kidemAyi < 0) {
    kidemYili--;
    kidemAyi += 12;
  }

  // 1 yıldan az — izin hakkı yok
  if (kidemYili < 1) {
    return {
      kidemYili,
      kidemAyi,
      kidemGunu,
      toplamGun,
      izinGunu: 0,
      izinDilimi: "1 yıldan az çalışma süresi",
      ozelYasUygulandiMi: false,
      ozelYasIzinGunu: 0,
      izinHakkiVar: false,
      hataMesaji: "Yıllık izin hakkı için en az 1 yıl çalışılması gerekir.",
    };
  }

  // İzin dilimi bul
  let izinGunu = 14;
  let izinDilimi = "";
  for (const dilim of IZIN_DILIMLERI) {
    if (kidemYili >= dilim.minYil && kidemYili < dilim.maxYil) {
      izinGunu = dilim.gun;
      izinDilimi = dilim.aciklama;
      break;
    }
  }

  // 18 yaş altı veya 50 yaş üstü kontrolü
  let ozelYasUygulandiMi = false;
  let ozelYasIzinGunu = 0;
  if (calIsanYasi !== undefined) {
    if (calIsanYasi < 18 || calIsanYasi > 50) {
      ozelYasIzinGunu = Math.max(izinGunu, OZEL_YAS_MINIMUM_IZIN);
      if (ozelYasIzinGunu > izinGunu) {
        ozelYasUygulandiMi = true;
      }
    }
  }

  return {
    kidemYili,
    kidemAyi,
    kidemGunu,
    toplamGun,
    izinGunu,
    izinDilimi,
    ozelYasUygulandiMi,
    ozelYasIzinGunu,
    izinHakkiVar: true,
    hataMesaji: null,
  };
}
